import * as Yup from 'yup';
import ParticipantsSource from '../../../core/constants/participantsSource';

export default Yup.object().shape({
  firstName: Yup.string()
    .when(['$project.company.collect_byo_testers_info', '$project.participantsSource'], {
      is: (collectByoTestersInfo, participantsSource) => !collectByoTestersInfo && participantsSource === ParticipantsSource.COMPANY,
      then: Yup.string(),
      otherwise: Yup.string().required('required'),
    }),
  lastName: Yup.string()
    .when(['$project.company.collect_byo_testers_info', '$project.participantsSource'], {
      is: (collectByoTestersInfo, participantsSource) => !collectByoTestersInfo && participantsSource === ParticipantsSource.COMPANY,
      then: Yup.string(),
      otherwise: Yup.string().required('required'),
    }),
});
